import { Action } from '@ngrx/store';

import { ErrCode, LinkListItem } from '../shared/models';

export const RESET = '[LinkList] Reset';
export const REFRESH = '[LinkList] Refresh';
export const ERROR = '[LinkList] Error';
export const SUCCESS = '[LinkList] Success';
export const SORT = '[LinkList] Sort';

export class LinkListSuccessAction implements Action {
  public readonly type = SUCCESS;
  constructor(public payload: LinkListItem[]) {}
}

export class LinkListResetAction implements Action {
  public readonly type = RESET;
}

export class LinkListRefreshAction implements Action {
  public readonly type = REFRESH;
}

export class LinkListErrorAction implements Action {
  public readonly type = ERROR;
  constructor(public payload: ErrCode) {}
}

export class LinkListSortAction implements Action {
  public readonly type = SORT;
  constructor(public payload: any) {}
}

export type All =
  | LinkListRefreshAction
  | LinkListResetAction
  | LinkListSuccessAction
  | LinkListErrorAction
  | LinkListSortAction;
